import {
  FETCH_FORM_START,
  FETCH_FORM_SUCCESS,
  FETCH_FORM_FAILED,
  FETCH_APPRAISAL_YEAR_OPTIONS_START,
  FETCH_APPRAISAL_YEAR_OPTIONS_SUCCESS,
  FETCH_APPRAISAL_YEAR_OPTIONS_FAILED,
  FETCH_ORGANIZATION_OPTIONS_START,
  FETCH_ORGANIZATION_OPTIONS_SUCCESS,
  FETCH_ORGANIZATION_OPTIONS_FAILED,
  FETCH_FEEDBACK_REPORT_DATA_FAILED,
  FETCH_FEEDBACK_REPORT_DATA_START,
  FETCH_FEEDBACK_REPORT_DATA_SUCCESS,
  SIGNOUT_SUCCESS,
  SIGNOUT_FAILED
} from '../../actions/actionTypes'

const initialState = {
  currentFilter: null,
  currentForm: null,
  records: [],
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  loadingStates: [],
  years: [],
  forms: [],
  orgs: []
}

const fetchFeedbackReportDataStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'records'] }
}

const fetchFeedbackReportDataSuccess = (state, { records, pagination, filter }) => {
  return {
    ...state,
    pagination,
    records,
    currentFilter: filter,
    currentForm: state.forms.find(item => item.form_id === filter.form_id) ?? null,
    loadingStates: state.loadingStates.filter(item => item !== 'records')
  }
}

const fetchFeedbackReportDataFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'records') }
}

const fetchFormOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'form_id'] }
}

const fetchFormOptionsSuccess = (state, { records }) => {
  return {
    ...state,
    forms: records,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id')
  }
}

const fetchFormOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'form_id') }
}

const fetchAppraisalYearOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'appraisal_year'] }
}

const fetchAppraisalYearOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    years: data,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_year')
  }
}

const fetchAppraisalYearOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'appraisal_year') }
}

const fetchOrgOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'org_id'] }
}

const fetchOrgOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    orgs: data
  }
}

const fetchOrgOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'org_id') }
}

export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case FETCH_FEEDBACK_REPORT_DATA_START:
      return fetchFeedbackReportDataStart(state, payload)
    case FETCH_FEEDBACK_REPORT_DATA_SUCCESS:
      return fetchFeedbackReportDataSuccess(state, payload)
    case FETCH_FEEDBACK_REPORT_DATA_FAILED:
      return fetchFeedbackReportDataFailed(state, payload)

    case FETCH_FORM_START:
      return fetchFormOptionsStart(state, payload)
    case FETCH_FORM_SUCCESS:
      return fetchFormOptionsSuccess(state, payload)
    case FETCH_FORM_FAILED:
      return fetchFormOptionsFailed(state, payload)

    case FETCH_APPRAISAL_YEAR_OPTIONS_START:
      return fetchAppraisalYearOptionsStart(state, payload)
    case FETCH_APPRAISAL_YEAR_OPTIONS_SUCCESS:
      return fetchAppraisalYearOptionsSuccess(state, payload)
    case FETCH_APPRAISAL_YEAR_OPTIONS_FAILED:
      return fetchAppraisalYearOptionsFailed(state, payload)

    case FETCH_ORGANIZATION_OPTIONS_START:
      return fetchOrgOptionsStart(state, payload)
    case FETCH_ORGANIZATION_OPTIONS_SUCCESS:
      return fetchOrgOptionsSuccess(state, payload)
    case FETCH_ORGANIZATION_OPTIONS_FAILED:
      return fetchOrgOptionsFailed(state, payload)

    case SIGNOUT_SUCCESS:
    case SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}
